export default "__VITE_ASSET__DSgAnzgm__"